import ApplicationModel, { attr } from '../ApplicationModel';
import { type AssistantToolCallAttributes } from './generated/AssistantToolCallAttributes';
import { model } from '../modelBuilder';

interface AssistantToolCall extends AssistantToolCallAttributes {}

@model
class AssistantToolCall extends ApplicationModel {
  // Start auto-generated
  static typename: 'AssistantToolCall' = 'AssistantToolCall';
  get typename(): 'AssistantToolCall' {
    return 'AssistantToolCall';
  }

  static internalTypename: 'Assistant::ToolCall' = 'Assistant::ToolCall';
  get internalTypename(): 'Assistant::ToolCall' {
    return 'Assistant::ToolCall';
  }

  static fields = {
    collapsable: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    description: attr({ readable: true }),
    icon: attr({ readable: true }),
    id: attr({ readable: true }),
    status: attr({ readable: true }),
    tool: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    artifact: attr.belongsTo({ readable: true, typename: 'AssistantArtifact' }),
    content: attr.belongsTo({ readable: true, typename: 'AssistantContent' }),
  };
  // End auto-generated
}

export default AssistantToolCall;
